import PropTypes from 'prop-types';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'app/lib/hooks';
import { Button, ButtonSize, ButtonVariant } from 'app/components/core/Button';
import { doShowNotification } from 'app/store/notifications';

export function CopyToClipboardButton({
    value,
    message = 'common:copiedToClipboard',
    iconOnly = false,
    ...props
}) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleClick = useCallback(async () => {
        await navigator.clipboard.writeText(value);
        dispatch(doShowNotification(message));
    }, [dispatch, message, value]);

    return (
        <Button
            variant={ButtonVariant.TERTIARY}
            size={ButtonSize.SMALL}
            icon="copy"
            onClick={handleClick}
            label={t('components:CopyToClipboardButton.label')}
            {...props}>
            {!iconOnly && t('components:CopyToClipboardButton.label')}
        </Button>
    );
}

CopyToClipboardButton.propTypes = {
    /**
     * Content to copy to clipboard
     */
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,

    message: PropTypes.string,
    iconOnly: PropTypes.bool
};
